import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useMasterData } from "../../context/MasterContextProvider";
import { SkillItem } from "../../models/master";
import { addSkillsApi, getSkillsApi } from "../../api/master";
import DropdownIcon from "../../assets/svg/dropdown.svg";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface Props {
  setPassedSkills: any;
  passedSkills: any[];
  error: string;
}

export default function AutocompleteBox({
  setPassedSkills,
  passedSkills,
  error,
}: Props) {
  const { skills, setSkills } = useMasterData();

  const getSkills = async () => {
    const resp = await getSkillsApi();
    if (resp) {
      setSkills(resp.data);
    }
  };

  function findSkillByName(skillName: string): SkillItem | undefined {
    return skills?.find(
      (skill) => skill.skillName.toLowerCase() === skillName.toLowerCase()
    );
  }

  const addSkill = async (skill: string): Promise<SkillItem | undefined> => {
    const added = await addSkillsApi(skill);
    if (added?.responseInfo.httpCode === 200) {
      await getSkills();
      return added.data;
    } else {
      const newSkill = findSkillByName(skill);

      if (newSkill) return newSkill;
      return {
        skillName: skill,
        skillId: "",
        _id: "",
      };
    }
  };

  const handleChange = async (_event: any, newValue: SkillItem[] | string[]) => {

    const formattedSkills = await Promise.all(
      newValue.map(async (skill) => {
        if (typeof skill === "object") {
          return {
            skillId: skill.skillId,
            skillName: skill.skillName,
            _id: skill._id,
          };
        } else {
          const data = await addSkill(skill); // Await the result of addSkill
          return data;
        }
      })
    );


    // Update the state with the formatted skills
    setPassedSkills(formattedSkills);
  };

  return (
    <Autocomplete
      multiple
      id="checkboxes-tags-demo"
      limitTags={3}
      freeSolo
      popupIcon={<img src={DropdownIcon} alt="dropdown" style={{ width: "14px", height: "9px" }} />}
      options={skills || []}
      onChange={handleChange}
      defaultValue={passedSkills}
      disableCloseOnSelect
      getOptionLabel={(option) =>
        typeof option === "object" ? option.skillName : option
      }
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li key={option._id} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.skillName}
          </li>
        );
      }}
      style={{ width: "100%" }}
      renderInput={(params) => (
        <TextField
          sx={{
            border: error && "1px solid red",
            borderRadius: error && "8px",
            '& .MuiAutocomplete-popupIndicator': {
              transform: 'none',
              '&:hover': {
                backgroundColor: 'transparent'
              }
            },
            '& .MuiAutocomplete-endAdornment': {
              right: '12px !important'
            }
          }}
          {...params}
          placeholder="Add skills"
        />
      )}
    />
  );
}
